export const formatCurrency = currencyVal => {
  return parseInt(currencyVal.toFixed(0)).toLocaleString('en-IN');
};
